<template>
  <div class="quality-recommend" ref="container">
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont icon-cuxiaoguanli"></span>促销单品
      </div>
      <div class="line"></div>
    </div>
    <Promotion-good :benefit="goodsList"></Promotion-good>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import PromotionGood from "@components/PromotionGood";
import { getGroomList } from "@api/store";
import Loading from "@components/Loading";
export default {
  name: "GoodsPromotion",
  components: {
    PromotionGood,
    Loading
  },
  props: {},
  data: function() {
    return {
      goodsList: [],
      where: {
        page: 1,
        limit: 20,
        type: 4
      }
    };
  },
  mounted: function() {
    this.loadend = false;
    this.loading = false;
    this.getIndexGroomList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndexGroomList();
    });
  },
  methods: {
    getIndexGroomList: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      let q = that.where;
      getGroomList(q)
        .then(res => {
          that.loading = false;
          that.goodsList.push.apply(that.goodsList, res.data.list);
          that.loadend = res.data.list.length < that.where.limit; //判断所有数据是否加载完成；
          that.where.page = that.where.page + 1;
        })
        .catch(function(res) {
          this.$dialog.toast({ mes: res.msg });
        });
    }
  }
};
</script>
